// extracted by mini-css-extract-plugin
export default {"wrap":"Or-z","logoContainer":"Pr-z","brandImg":"Qr-z","logoImg":"Rr-z","logoButton":"Sr-z"};